<div class="line-items">
  <table [cellPadding]="0" [cellSpacing]="0">
    <tr>
      <th>ID</th>
      <th>Image</th>
      <th>Product Name</th>
      <th>Delivery Date</th>
      <th>Quantity</th>
      <th *ngIf="isAttachmentTrue">Attachment</th>
    </tr>
    <tr *ngFor="let line of lineItems">
      <td>{{ line?.productId }}</td>
      <td><img src="{{ line?.imageUrl }}" /></td>
      <td>{{ line?.productName }}
          <lucide-icon
            name="info"
            *ngIf="line?.requirements"
            [size]="14"
            (mouseenter)="showTooltip(line?.productId, true)"
            (mouseleave)="showTooltip(line?.productId, false)"
          ></lucide-icon>
          <div *ngIf="tooltipState[line?.productId]" class="custom-tooltip">
            <b>Additional Requirment:</b>
            {{ line?.requirements }}
          </div>
      </td>
      <td>{{ line?.deliveryDate | date: "dd-MM-YYYY" }}</td>
      <td>{{ line?.quantity || line?.itemQuantity }}</td>
      <td *ngIf="isAttachmentTrue">
        <div class="flex file-upload-status alignCenter" *ngIf="line?.attachment?.fileName !== null">
          <div class="col-lg-9 col-md-9 col-sm-9 flex alignCenter">
            <span class="file-name" matTooltip="{{ line?.attachment.fileName }}  {{ line?.attachment.size }}" matTooltipPosition="left">
              {{ getTruncatedString(line?.attachment.fileName) }}...</span
            >
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 file-upload-size-info flex alignCenter">
            <span (click)="downloadBrochureFile(line?.attachment.id, line?.attachment.fileName)">
              <mat-icon>save_alt</mat-icon>
            </span>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
